
import { Component, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/forms/form2";
const form2State = namespace("Form2");

import Form2ProcessHeader from "@/components/process/Form2/components/Form2ProcessHeader.vue";
import Spinner from "@/components/utils/Spinner.vue";
import { packageInfoType } from '@/types/Information';
import { form2StatusInfoType } from '@/types/Information/Form2';

@Component({
    components:{
        Form2ProcessHeader,
        Spinner
    }
})
export default class SubmitForm2 extends Vue {

    @form2State.State
    public currentCaseId: string;

    stepsCompleted = {} as form2StatusInfoType;  
    mountedData = false; 
    packageInfo = {} as packageInfoType;
    submitting = false;
    errorMsg=""

    mounted() {
        this.mountedData = false;    
        this.submitting = false;    
        this.errorMsg = ""
        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;         
    }  

    public submit() {

        this.submitting = true;
        this.errorMsg =""

        const url = "/efiling/"+this.currentCaseId+"/submit/";

        const header = {
            responseType: "json",
            headers: {
                "Content-Type": "application/json",
            }
        }

        this.$http.post(url, header)
        .then(res => {                            
            // this.submitting = false;
            if(res.data?.message=="success" && res.data?.redirectUrl){
                const eFilingUrl = res.data?.redirectUrl
                location.replace(eFilingUrl);
            }else
                this.submitting = false;
        }, err => {
            console.log(err.response?.data?.message);
            const generalError = " Error in submission. Please refresh the page and try again."
            if(err.response?.data?.message)
                this.errorMsg = err.response.data.message
            else if(err.response?.data?.detail)
                this.errorMsg = err.response.data.detail+generalError
            else
                this.errorMsg = generalError
            this.submitting = false;
        });        
    }

    public cancel() {
        this.$router.push({name: "dashboard" }) 
    }
}
